import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=92b2a9f6&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=92b2a9f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b2a9f6",
  null
  
)

export default component.exports